/* theme.js — Maison Lore v2 */
(function () {
  'use strict';

  /* ── Nav Drawer ──────────────────────────────────────────── */
  const drawer  = document.getElementById('nd-drawer');
  const overlay = document.getElementById('nd-overlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    document.querySelectorAll('.burger-btn').forEach(b => b.classList.add('active'));
    drawer.querySelector('.nd-close')?.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    document.querySelectorAll('.burger-btn').forEach(b => b.classList.remove('active'));
  }
  document.querySelectorAll('.burger-btn, [data-open-drawer]').forEach(b => b.addEventListener('click', openDrawer));
  overlay?.addEventListener('click', closeDrawer);
  document.getElementById('nd-close-btn')?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  window.openNavDrawer  = openDrawer;
  window.closeNavDrawer = closeDrawer;

  /* ── Header scroll shadow ────────────────────────────────── */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Header search toggle ────────────────────────────────── */
  const searchWrap  = document.getElementById('header-search');
  const searchInput = document.getElementById('header-search-input');
  document.getElementById('search-open-btn')?.addEventListener('click', () => {
    searchWrap?.classList.add('open');
    searchInput?.focus();
  });
  document.getElementById('search-close-btn')?.addEventListener('click', () => {
    searchWrap?.classList.remove('open');
  });

  /* ── Scroll reveal ───────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('visible'));
  }

  /* ── Cart count badge ────────────────────────────────────── */
  function refreshCart() {
    fetch('/cart.js').then(r => r.json()).then(cart => {
      document.querySelectorAll('.cart-badge').forEach(b => {
        b.textContent = cart.item_count > 9 ? '9+' : cart.item_count;
        b.classList.toggle('show', cart.item_count > 0);
      });
    }).catch(() => {});
  }
  refreshCart();

  /* ── Quick Add ───────────────────────────────────────────── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    const orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.style.pointerEvents = 'none';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: 1 })
    }).then(() => {
      btn.textContent = 'Added ✓';
      refreshCart();
      setTimeout(() => { btn.textContent = orig; btn.style.pointerEvents = ''; }, 2200);
    }).catch(() => { btn.textContent = 'Error'; btn.style.pointerEvents = ''; });
  });

  /* ── Product variant picker ──────────────────────────────── */
  const swatches = document.querySelectorAll('.swatch');
  if (swatches.length) {
    swatches.forEach(s => s.addEventListener('click', () => {
      if (s.classList.contains('unavailable')) return;
      s.closest('.swatch-row')?.querySelectorAll('.swatch').forEach(x => x.classList.remove('active'));
      s.classList.add('active');
      updateVariant();
    }));
    function updateVariant() {
      const selected = [];
      document.querySelectorAll('.swatch-row').forEach(row => {
        const a = row.querySelector('.swatch.active');
        if (a) selected.push(a.dataset.value);
      });
      const variants = window.__productVariants || [];
      const match = variants.find(v => v.options.every((o, i) => !selected[i] || o === selected[i]));
      if (!match) return;
      document.getElementById('variant-id').value = match.id;
      const priceEl = document.getElementById('product-price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      const atcBtn = document.querySelector('.product-atc');
      if (atcBtn) { atcBtn.disabled = !match.available; atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out'; }
    }
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    }
  }

  /* ── Gallery thumbnails ──────────────────────────────────── */
  document.querySelectorAll('.product-gallery-thumbs button').forEach(btn => {
    btn.addEventListener('click', () => {
      const src = btn.dataset.src;
      const main = document.getElementById('main-img');
      if (main && src) main.src = src;
      btn.closest('.product-gallery-thumbs')?.querySelectorAll('button').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ── Cart qty controls ───────────────────────────────────── */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    const action  = btn.dataset.cartChange;
    const lineKey = btn.dataset.key;
    const qtyEl   = btn.closest('.cart-qty-row')?.querySelector('.cart-qty-num');
    const current = parseInt(qtyEl?.textContent || '1');
    const newQty  = action === 'inc' ? current + 1 : Math.max(0, current - 1);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: newQty })
    }).then(() => location.reload()).catch(() => {});
  });

  /* ── Newsletter form ─────────────────────────────────────── */
  document.querySelector('.newsletter-form')?.addEventListener('submit', e => {
    const input = e.target.querySelector('input[type=email]');
    const btn   = e.target.querySelector('button');
    if (!input?.value) { e.preventDefault(); return; }
    // let Shopify handle the actual POST, just update UI on success hint
    btn.textContent = 'Subscribed ✓';
  });

  /* ── Marquee clone for seamless loop ─────────────────────── */
  document.querySelectorAll('.marquee-track').forEach(track => {
    track.insertAdjacentHTML('beforeend', track.innerHTML);
  });

  /* ── Announcement bar close ──────────────────────────────── */
  document.getElementById('announcement-close')?.addEventListener('click', () => {
    document.querySelector('.announcement-bar')?.classList.add('announcement-bar--hidden');
  });

})();
